<style type="text/css">

.filter-btn{
	display: inline-block;
	background-color: #ffff;
}
</style>
<template>
	<div>
		<div class="mt-5">
			<wallet-amount :return_count="return_count" :current_balance="current_balance" @initiate-withdrawal="initiateWithdrawal" />
		</div>
		<!--  sechand filter section -->
		<v-row class="my-4">
			<v-col cols="9" md="6">
				<v-text-field
				v-model="withdrawal_serch_query"
				:placeholder="$lang.WALLET_SEARCH"
				outlined
				rounded
				dense
				@keyup="getWithdrawalList"
				append-icon="mdi-magnify"
				hide-details
				></v-text-field>
			</v-col>
			<v-col cols="3" md="1" class="text-right">
				<div @click="$store.dispatch('setWalletFilterDialog', true)"  class="cursor-pointer w-max-content">
					<filter-btn  :filter_count="filter_data.filter_count"/>
				</div>
			</v-col>
			<v-col cols="9" md="2" class="pl-8">
				<v-btn  rounded depressed  outlined  class="download-svg-btn" width="151px"  @click="downloadCsv" >
					<img src="@/assets/download.svg" alt="">
					{{$lang.DOWNLOAD_CSV}}
				</v-btn>

			</v-col>
		</v-row>

		<span class="page-title"> {{$lang.WITHDRAWAL_HISTORY.toUpperCase()}}</span>
		
		<div class="my-4">
			<v-data-table
			v-model="selected"
			:headers="headers"
			:items="withdrawal_history_list"
			item-key="transaction_id"
			:hide-default-footer="true"
			:disable-sort="true"
			class="elevation-1 custome-header-bg custome-table-body"
			show-select
			:items-per-page="$keys.PAGE_LENGTH"
			:single-select="singleSelect"
			:loading="table_loading"
			@click:row="gotoWidthdrwalDetails"
			>
			<template v-slot:item.status="{ item }">
				<span :class="'transaction_'+item.status.toLowerCase()">{{item.status}}</span>
			</template>	
			<template v-slot:item.action="{ item }">

				<v-btn	 small fab text
				@click="gotoWidthdrwalDetails(item)">
				<img src="../../assets/arrow-right.svg" alt="">	
			</v-btn>
		</template>	
		<!--  empty state  -->
		<template v-slot:no-data>
			<empty-list :message="$lang.EMPTY_TRANSACTION"/>
		</template>	
	</v-data-table>

	<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
	@input="getWithdrawalList"></v-pagination>

</div>

<wallet-filter :filter_data="filter_data" @filter="getWithdrawalList" />
<confirm-withdrawal-dialog :dialog="dialog" />

</div>
</template>

<script type="text/javascript">
export default{
	components:{
		WalletAmount:()=>import('./child/WalletAmount.vue'),
		WalletFilter:()=>import('./child/WalletFilter.vue'),
		ConfirmWithdrawalDialog:()=>import('./child/ConfirmWithdrawalDialog.vue'),
		FilterBtn :()=>import('@/components/common-components/FilterBtn.vue'),

	},
	watch: {
		selected: {
			handler(newVal, oldVal){
				if(newVal != oldVal){
					this.getTransactionIdList()
				}
			},
			deep: true
		}
	},
	data(){
		return{
			withdrawal_serch_query:"",
			return_count:0,
			current_balance:0,
			withdrawal_history_list:[],
			selected:[],
			transaction_id_list:[],
			page_number:1,
			total_page_count:1,
			table_loading:false,
			singleSelect:false,
			filter_data:{
				wholesaler_id_list:[],
				reciever_list:[],
				filter_date_from:"",
				filter_date_to:"",
				filter_count:0,
			},

			headers: [
			{text: '#Transaction ID', align: 'start', sortable: false, value: 'transaction_id',},
			{ text: 'Transaction Date', value: 'created_date' },
			{ text: 'Time', value: 'created_time' },
			{ text: 'Amount', value: 'amount' },
			{ text: 'No of Shipments', value: 'shipment_count' },
			{ text: 'Status', value: 'status' ,},
			{ text: '', value: 'action' , width:"30"},
			],

			dialog:{
				flag:false,
				item:{
					date:null,
					time:null,
					amount:null,
					mobile:null,
					otp_token:null,
					otp:null,
				}
			},
		}
	},
	created(){
		this.getWithdrawalList()
	},
	methods:{
		/* fetching withdrwal hitory list*/ 
		getWithdrawalList() {
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				search_query:this.withdrawal_serch_query,
				filter_date_from:this.filter_data.filter_date_from,
				filter_date_to:this.filter_data.filter_date_to,
			};
			self.table_loading=true

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					this.withdrawal_history_list=response.data.withdrawal_history_list
					this.total_page_count=response.data.total_page_count
					this.current_balance=response.data.amount
					this.return_count=response.data.returned_count

				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.WITHDRAWAL_HISTORY,params,successHandler,null,null,finallyHandler)
		},
		/* get transaction id  list  for selected transaction */ 
		getTransactionIdList(){
			this.transaction_id_list=[]
			for (let i = 0; i < this.selected.length; i++) {
				this.transaction_id_list.push(this.selected[i].transaction_id)

			}
			this.transaction_id_list=JSON.stringify(this.transaction_id_list)

		},
		/* redirect to transaction/ withdrawal details*/ 
		gotoWidthdrwalDetails(transaction){
			console.log(transaction)
			this.$router.push({name:'withdrawal-details',params:{'transaction_id':this.encript(transaction.transaction_id)}})
		},
		
		/* initiate withdrwal */ 
		initiateWithdrawal(){
			const self=this;
			var	form = new FormData();
			const successHandler = (response) => {
				if (response.data.success){
					this.transaction_id=response.data.id;
					this.dialog.item.date=response.data.created_date;
					this.dialog.item.time=response.data.created_time;
					this.dialog.item.amount=response.data.amount;
					this.dialog.item.returned_count=response.data.returned_count;
					this.dialog.item.mobile=response.data.wholesaler_mobile_number;
					this.dialog.item.otp_token=response.headers["otp-token"]
					this.dialog.otp=response.data.otp;
					this.dialog.flag=true
					this.getWithdrawalList()

				}
			};
			this.request_POST(self,this.$urls.INITIATE_WITHDRAW,form,successHandler)
		},

		/* Download Csv*/ 
		downloadCsv(){
			if(this.selected.length==0){
				this.showSnakeBar("warning",this.$messages.NO_TRANSACTION_SELECTED,)
				return false
			}
			window.open(this.$urls.BASE_URL+this.$urls.WITHDRAW_CSV+'?withdrawal_id_list='+this.transaction_id_list, "_blank"); 
		}

	}
}
</script>